import { Box } from '@mui/material';

export const CurrentPlanStage = (props: { name?: string }) => {
  return (
    <Box
      aria-current="page"
      sx={{
        alignItems: 'center',
        backgroundColor: 'transparent',
        border: 1,
        borderColor: 'common.white',
        borderRadius: 1,
        color: 'common.white',
        display: 'inline-flex',
        fontSize: '0.875rem',
        fontWeight: 500,
        justifyContent: 'center',
        letterSpacing: '0.02857em',
        lineHeight: 1.75,
        minHeight: 36,
        paddingX: 1.875,
        textTransform: 'uppercase',
      }}
    >
      {props.name}
    </Box>
  );
};
